export default "__VITE_ASSET__BPQGscMr__"